import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { DropdownItem } from 'ui-components';
import { PersonIcon } from 'ui-components/dist/PersonIcon';
import { trackEvent } from '~/core/utils/trackEvent';
import { ICreator } from '~/types';

interface IViewProfileDropdownItem {
  creator: ICreator;
  isShared?: boolean;
}

export const ViewProfileDropdownItem: React.FC<IViewProfileDropdownItem> = ({
  creator,
  isShared,
}) => {
  const router = useRouter();

  const handleClick = useCallback(async () => {
    if (isShared) {
      trackEvent('foam-view-creator-from-talent-stacked-view');
      router.push(`/shared/talent/${creator.slug}`);
      return;
    }

    trackEvent('foam-view-creator-from-talent-stacked-view');
    router.push(`/t/${creator.slug}`);
  }, [creator, isShared, router]);

  return (
    <DropdownItem
      track-id="foam-view-creator-from-talent-page"
      onClick={handleClick}
    >
      <PersonIcon boxSize={4} />
      View Profile
    </DropdownItem>
  );
};
